// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3Jsqk","itemTitle":"ClientEmergencyInfo_itemTitle__uu4Qw","itemText":"ClientEmergencyInfo_itemText__1B4MJ"};